import React from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import Modal from '../../modal'

class EmailContentModal extends React.Component {
  constructor(props) {
    super(props)

    const contents = props.contents || []
    const hasHtml = contents.some(c => c.content_type === 'text/html')

    this.state = {
      activeTab: hasHtml ? 'text/html' : 'text/plain'
    }
  }

  render() {
    const contents = this.props.contents || []
    const htmlContent = contents.find(c => c.content_type === 'text/html')
    const textContent = contents.find(c => c.content_type === 'text/plain')

    return (
      <Modal title={this.props.subject || 'Email Preview'} onClose={this.props.onClose}>
        <div className="p-6">
          {contents.length === 0 &&
            <div className="p-10 text-center text-sm text-muted-foreground">No content recorded for this email.</div>
          }

          {contents.length > 0 &&
            <div>
              {htmlContent && textContent &&
                <Tabs
                  value={this.state.activeTab}
                  onValueChange={(value) => this.setState({ activeTab: value })}
                  className="mb-4"
                >
                  <TabsList>
                    <TabsTrigger value="text/html">HTML</TabsTrigger>
                    <TabsTrigger value="text/plain">Text</TabsTrigger>
                  </TabsList>
                </Tabs>
              }

              {this.state.activeTab === 'text/html' && htmlContent &&
                <iframe
                  srcDoc={htmlContent.body}
                  className="h-[600px] w-full rounded border"
                  sandbox=""
                />
              }

              {this.state.activeTab === 'text/plain' && textContent &&
                <pre className="max-h-[600px] overflow-auto whitespace-pre-wrap break-words rounded-md border border-border bg-muted p-4 text-sm">
                  {textContent.body}
                </pre>
              }
            </div>
          }
        </div>
      </Modal>
    )
  }
}

export default EmailContentModal
